import {
  mdiClose,
  mdiBellRing,
  mdiHelpCircle,
  mdiAlertCircle,
  mdiCloseCircle,
  mdiCheckCircle,
  mdiClipboardCheckOutline,
  mdiEye,
  mdiEyeOff,
} from "@mdi/js";

const iconList = {
  mdiClose,
  mdiBellRing,
  mdiHelpCircle,
  mdiAlertCircle,
  mdiCloseCircle,
  mdiCheckCircle,
  mdiClipboardCheckOutline,
  mdiEye,
  mdiEyeOff,
};

export default iconList;
